import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Downshift from 'downshift';
import Isvg from 'react-inlinesvg';
import { intlShape } from 'react-intl';
import { deepExtract } from 'helpers/deep';
export var SearchBoxField =
/*#__PURE__*/
function (_Component) {
  _inherits(SearchBoxField, _Component);

  function SearchBoxField() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SearchBoxField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SearchBoxField)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "inputRef", React.createRef());

    _defineProperty(_assertThisInitialized(_this), "blurInput", function () {
      var input = deepExtract('current', _this.inputRef);

      if (input) {
        input.blur();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelect", function (item) {
      var _this$props = _this.props,
          onSelect = _this$props.onSelect,
          onValueChange = _this$props.onValueChange,
          onClose = _this$props.onClose;

      _this.downshift.closeMenu();

      _this.blurInput();

      onValueChange('');
      onClose();
      onSelect(item);
    });

    _defineProperty(_assertThisInitialized(_this), "handleClear", function () {
      var onClear = _this.props.onClear;

      _this.downshift.clearSelection();

      onClear();
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      var onValueChange = _this.props.onValueChange;
      onValueChange(event.target.value);
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function () {
      var _this$props2 = _this.props,
          onFieldFocus = _this$props2.onFieldFocus,
          onValueChange = _this$props2.onValueChange;
      onValueChange('');
      onFieldFocus();
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function () {
      var _this$props3 = _this.props,
          onValueChange = _this$props3.onValueChange,
          onClose = _this$props3.onClose,
          isOpenPanelOnMobile = _this$props3.isOpenPanelOnMobile;

      if (!isOpenPanelOnMobile) {
        onValueChange('');
        onClose();
      }
    });

    return _this;
  }

  _createClass(SearchBoxField, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          isOpen = _this$props4.isOpen,
          inputValue = _this$props4.inputValue,
          blurredValue = _this$props4.blurredValue,
          isOpenPanelOnMobile = _this$props4.isOpenPanelOnMobile,
          itemToString = _this$props4.itemToString,
          placeholder = _this$props4.placeholder,
          children = _this$props4.children,
          icon = _this$props4.icon,
          isClearable = _this$props4.isClearable;
      return React.createElement("div", {
        className: classNames('searchbox__input', {
          'searchbox__input--selected': isOpen
        })
      }, React.createElement("div", {
        className: "searchbox__input__icon"
      }, icon), React.createElement(Downshift, {
        isOpen: isOpen,
        inputValue: isOpen ? inputValue : blurredValue,
        onSelect: this.handleSelect,
        itemToString: itemToString
      }, function (downshift) {
        _this2.downshift = downshift;
        var getInputProps = downshift.getInputProps,
            isOpenLocal = downshift.isOpen;
        return React.createElement("div", null, React.createElement("input", _extends({}, getInputProps({
          autoComplete: 'off',
          onChange: _this2.handleChange,
          onFocus: _this2.handleFocus,
          onBlur: _this2.handleBlur,
          placeholder: placeholder
        }), {
          autoFocus: isOpen // eslint-disable-line jsx-a11y/no-autofocus
          ,
          ref: _this2.inputRef
        })), isOpenLocal && children(_objectSpread({
          onPanelScroll: isOpenPanelOnMobile ? _this2.blurInput : undefined
        }, downshift)));
      }), isClearable && blurredValue && !isOpenPanelOnMobile && React.createElement("div", {
        className: "searchbox__input__icon searchbox__input__icon--light",
        onClick: this.handleClear
      }, React.createElement(Isvg, {
        src: require('../../../../static/design-system/icons/cross-small-circle.svg')
      })));
    }
  }]);

  return SearchBoxField;
}(Component);
SearchBoxField.propTypes = {
  children: PropTypes.func.isRequired,
  blurredValue: PropTypes.string.isRequired,
  inputValue: PropTypes.string.isRequired,
  intl: intlShape.isRequired,
  isOpen: PropTypes.bool,
  isOpenPanelOnMobile: PropTypes.bool,
  isClearable: PropTypes.bool,
  itemToString: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  icon: PropTypes.node,
  onClear: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onFieldFocus: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  onValueChange: PropTypes.func.isRequired
};